
(function () {
  // デバイス確認 
  const device = navigator.userAgent.match(/iphone|ipad|ipod|android/i) ? "sp" : "pc";

  // スライダー
  let prevImgSwiper
  let prevImgMainSlider

  /**
   * swiperの設定
   */
  function initSwiper() {
    let spaceBetween = 30
    if (window.matchMedia("(orientation: landscape) and (max-width: 1000px)").matches) {
      spaceBetween = 10
    }
    prevImgSwiper = new Swiper('.prevImg-swiper', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 10,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      breakpoints: {
        769: {
          spaceBetween: spaceBetween,
        }
      }
    });
    prevImgMainSlider = new Swiper(".prevImg-main-slider", {
      slidesPerView: 1,
    });
    prevImgMainSlider.controller.control = prevImgSwiper;
    prevImgSwiper.controller.control = prevImgMainSlider;
  }
  /**
   * 入稿された画像の移動、サイズ切り替え処理の設定 c
   */
  function initMoveEvent() {
    // デバイス別のイベント名を格納
    let touchstart = device == "sp" ? "touchstart" : "mousedown";
    let touchend = device == "sp" ? "touchend" : "mouseup";
    let touchmove = device == "sp" ? "touchmove" : "mousemove";

    // 画像のイベントを設定
    document.querySelectorAll(".prevImg-target,.prevImg-resize-thumb").forEach(function (e, i) {
      // 識別クラスを設定
      e.classList.add("--drag-ready")

      // 画像タッチ時のイベント
      e.addEventListener(touchstart, function (event) {
        event.preventDefault();

        // 位置取得 デバイスに応じて取得対象を変える
        let x = device == "sp" ? event.touches[0].clientX : event.clientX;
        let y = device == "sp" ? event.touches[0].clientY : event.clientY;

        // タップ対象の移動に必要なデータを設定
        let attributes = {
          "data-start": true,
          "data-move": false,
          "data-initialX": x,
          "data-initialY": y,
          "data-top": window.getComputedStyle(e).getPropertyValue('top').replace("px", "") ?? 0,
          "data-left": window.getComputedStyle(e).getPropertyValue('left').replace("px", "") ?? 0,
        }
        for (const key in attributes) {
          e.setAttribute(key, attributes[key])
        }
      })

      // move後のクリックを無効化
      e.addEventListener("click", function (event) {
        if (e.getAttribute("data-move") == "true") {
          return false
        }
      });

      e.addEventListener(touchend, function (event) {
        e.setAttribute("data-start", false)
        e.setAttribute("data-move", false)
      });
    })

    // カーソルの移動イベントの設定
    document.querySelector(".prevImg-in").addEventListener(touchmove, (event) => {
      let target = document.querySelector(".prevImg-in .--drag-ready[data-start=true]")
      if (target?.getAttribute("data-start") != "true") {
        return
      }

      // targetがタップされていたら
      event.preventDefault();

      let x = device == "sp" ? event.touches[0].clientX : event.clientX;
      let y = device == "sp" ? event.touches[0].clientY : event.clientY;
      let moveX = x - Number(target.getAttribute("data-initialX")); // ドラッグ距離 X
      let moveY = y - Number(target.getAttribute("data-initialY")); // ドラッグ距離 Y
      if ((moveX < -1 || moveX > 1) || (moveY < -1 || moveY > 1)) {  // ドラッグ距離が0以外だったら
        target.getAttribute("data-move", true)
        target.style.position = "absolute"
      }

      // 初期位置にドラッグ距離を加算して移動させる
      if (target.classList.contains("prevImg-resize-thumb")) {
        let thumbHeight = document.querySelector(".prevImg-resize-thumb").clientHeight / 2
        let resizeHeight = document.querySelector(".prevImg-resize").clientHeight
        let resizeRange = resizeHeight

        let top
        if (window.matchMedia("(max-width:768px)").matches) {
          if (window.matchMedia("(orientation: landscape) and (max-width: 1000px)").matches) {
            top = Number(target.getAttribute("data-top")) + moveY;
          } else {
            top = Number(target.getAttribute("data-top")) + moveX;
          }
        } else {
          top = Number(target.getAttribute("data-top")) + moveY;
        }

        if (top < -thumbHeight) {
          top = -thumbHeight
        } else if (top > resizeHeight - thumbHeight) {
          top = resizeHeight - thumbHeight
        }
        target.style.top = top + "px"
        document.querySelector(".prevImg-target").style.width = "calc(3vw + 24 * " + (top + thumbHeight) / resizeRange + "vw)"
      } else {
        target.style.top = Number(target.getAttribute("data-top")) + moveY * 2 + "px";
        target.style.left = Number(target.getAttribute("data-left")) + moveX * 2 + "px";
      }
    })
    let touchendHandler = (event) => {
      let target = document.querySelector(".prevImg-in .--drag-ready[data-start=true]")
      if (target?.getAttribute("data-start") != "true") {
        return
      }

      // targetがタップされていたら
      target.setAttribute("data-start", false);
    }
    document.querySelector(".prevImg-in").addEventListener(touchend, touchendHandler)
    document.querySelector(".prevImg-in").addEventListener("mouseleave", touchendHandler)
  }
  /**
   * 入稿処理
   */
  function initInputImgEvent() {
    document.querySelectorAll(".prevImg-option-img:not(.--backimg) .prevImg-option-img__input,#fileUploadPreview").forEach(function (e, i) {
      e.addEventListener('change', function (event) {
        let file = event.target.files[0];
        if (!file) {
          return
        }

        let blobUrl = window.URL.createObjectURL(file);
        document.querySelector(".prevImg-target img").setAttribute("src", blobUrl)

        if (!document.body.classList.contains("--show-popup")) {
          document.body.classList.add("--show-popup")
        }
      });
    })
  }
  /**
   * 背景画像の入稿処理
   */
  function initInputBackImgEvent() {
    document.querySelectorAll(".prevImg-option-img.--backimg .prevImg-option-img__input").forEach(function (e, i) {
      e.addEventListener('change', function (event) {
        let file = event.target.files[0];
        if (!file) {
          return
        }

        let blobUrl = window.URL.createObjectURL(file);
        prevImgMainSlider.prependSlide(
          '<div class="swiper-slide"><img src="' + blobUrl + '" /></div>'
        );
        prevImgSwiper.prependSlide(
          '<div class="swiper-slide"><img src="' + blobUrl + '" /></div>'
        );
        prevImgMainSlider.slideTo(0)
      });
    })
  }
  /**
   * クローズ処理
   */
  function initCloseBtnEvent() {
    document.querySelector(".popup-overlay .popup-close").addEventListener("click", () => {
      document.body.classList.remove("--show-popup")
    })
  }
  /**
   * 横幅の変更があった際の処理
   */
  function initMatchMediaEvent() {
    // spで画面を横にした場合
    window.matchMedia("(orientation: landscape) and (max-width: 1000px)").addEventListener("change", (ev) => {
      if (ev.matches) {
        document.querySelector(".prevImg-resize-thumb").style.top = window.getComputedStyle(document.querySelector(".prevImg-resize-thumb")).getPropertyValue('top').replace("px", "") * 0.653 + "px"
      }
    })
  }

  document.addEventListener('DOMContentLoaded', function () {
    // 各種機能の初期化
    initSwiper()
    initMoveEvent()
    initInputImgEvent()
    initInputBackImgEvent()
    initCloseBtnEvent()
    initMatchMediaEvent()
  })
})()